document.addEventListener("DOMContentLoaded", function(event) {
  const wrapper = document.querySelector('.lp-block-sidebar');
  const button  = document.querySelector('.lp-block-sidebar__left-text-wrapper');
  const text    = document.querySelector('.lp-block-sidebar__title');

  button.addEventListener('click', function() {
    if (window.innerWidth < 960) {
      wrapper.classList.toggle('active');
    }
  });

  text.addEventListener('click', function() {
    if (window.innerWidth < 960) {
      wrapper.classList.toggle('active');
    }
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth >= 960) {
      wrapper.classList.remove('active');
    }
  });

  document.addEventListener('click', function(event) {
    if (!wrapper.contains(event.target) && !button.contains(event.target)) {
      wrapper.classList.remove('active');
    }
  });
});